/** @jsxImportSource @emotion/react */

import {
  Card,
  Currency,
  Icon,
  IconName,
  MoneyScaled,
  removeScaleFromMoney,
  Typography,
  useTheme,
} from '@quickbit/qb-design-system';
import { formatCurrency } from '../utils';
import { TruncatedString } from './TruncatedSting';

// example balances: { "USDC": { "USDC": <money>, "EUR": <money> }, "USDT": { "USDT": <money>, "EUR": <money> }}
interface Props {
  balances: Record<string, Record<string, MoneyScaled | string>>;
  addresses: Record<string, string>;
}

export const Balances = ({ balances, addresses }: Props) => {
  const { spacing, palette } = useTheme();
  return (
    <div
      css={{
        display: 'grid',
        gridTemplateColumns: `repeat(${Object.keys(balances).length}, ${
          spacing.xxxl
        })`,
        gap: spacing.xxs,
        overflowX: 'scroll',
      }}
    >
      {Object.entries(balances).map(([key, balanceObj]) => (
        <Card
          key={key}
          css={{
            display: 'flex',
            flexDirection: 'column',
            gap: spacing.xxxs,
          }}
        >
          <Typography variant="subtitle">{key.toUpperCase()}</Typography>
          <div
            css={{
              display: 'flex',
              gap: spacing.xxxs,
              alignItems: 'center',
            }}
          >
            <Icon name={key.toUpperCase() as IconName} size={spacing.s} />
            <div css={{ display: 'flex', flexDirection: 'column' }}>
              <Typography variant="heading2">
                {removeScaleFromMoney(
                  balanceObj[key as Currency] as MoneyScaled
                )}
              </Typography>
              {addresses[key] &&
                TruncatedString({ text: addresses[key], split: 6 })}
              {balanceObj.eur && (
                <Typography variant="bodySmall" color={palette.grey.default}>
                  {formatCurrency(balanceObj.eur as MoneyScaled)}
                </Typography>
              )}
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};
